import { BRAND } from "@/lib/branding";

const BrainMark = ({ className }) => (
  <svg viewBox="0 0 64 64" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    {/* left circuit hemisphere */}
    <path d="M30 10c-4-3-11-2-14 2-5 1-8 5-8 9-4 2-5 7-3 11-2 3-1 8 3 10 1 5 6 8 11 7 3 2 8 2 11-1V10z"
      stroke="currentColor" strokeWidth="2.2" strokeLinejoin="round" fill="rgba(47,123,246,0.10)" />
    <g stroke={BRAND.accent} strokeWidth="1.8" strokeLinecap="round">
      <path d="M30 20H20l-4 4" />
      <path d="M30 32H16l-4 4" />
      <path d="M30 44H21l-4 4" />
      <path d="M24 15v-3" />
    </g>
    <g fill={BRAND.accent}>
      <circle cx="12" cy="24" r="2" />
      <circle cx="12" cy="36" r="2" />
      <circle cx="17" cy="48" r="2" />
      <circle cx="24" cy="12" r="2" />
      <circle cx="30" cy="20" r="1.8" />
      <circle cx="30" cy="32" r="1.8" />
    </g>
    {/* right organic hemisphere */}
    <path d="M34 10c4-3 11-2 14 2 5 1 8 5 8 9 4 2 5 7 3 11 2 3 1 8-3 10-1 5-6 8-11 7-3 2-8 2-11-1V10z"
      stroke="currentColor" strokeWidth="2.2" strokeLinejoin="round" fill="rgba(255,255,255,0.04)" />
    <g stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" opacity="0.8">
      <path d="M40 16c3 1 4 4 3 7" />
      <path d="M44 26c3 1 4 4 2 7" />
      <path d="M40 38c3 0 5 3 4 6" />
      <path d="M38 48c2 0 4 2 4 4" />
    </g>
  </svg>
);

export const BrandLogo = ({ size = "md" }) => {
  const icon = size === "sm" ? "h-6 w-6" : "h-7 w-7";
  const text = size === "sm" ? "text-base" : "text-lg";
  return (
    <div className="flex items-center gap-2.5 select-none" data-testid="brand-logo">
      <BrainMark className={`${icon} text-white`} />
      <span className={`font-display ${text} font-bold tracking-[0.18em] leading-none`}>
        <span className="text-white">{BRAND.name}</span>
        <span style={{ color: BRAND.accent }} className="ml-1.5">{BRAND.suffix}</span>
      </span>
    </div>
  );
};
